import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(1.5),
		height: `calc(100% - 48px)`,
		minHeight: "calc(100dvh - 48px)",
		position: "relative",
		zIndex: 1,
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1),
			minHeight: "calc(100dvh - 56px)",
		},
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
		borderRadius: 18,
		background: theme.mode === "light" ? "rgba(255,255,255,0.56)" : "rgba(12,20,39,0.54)",
		border: `1px solid ${theme.palette.divider}`,
		backdropFilter: "blur(10px)",
		WebkitBackdropFilter: "blur(10px)",
		boxShadow: theme.mode === "light"
			? "0 20px 40px rgba(8, 16, 34, 0.08)"
			: "0 26px 48px rgba(0, 0, 0, 0.28)",
		[theme.breakpoints.down("sm")]: {
			borderRadius: 14,
			backdropFilter: "none",
			WebkitBackdropFilter: "none",
		},
	},
}));

const MainContainer = ({ children, className }) => {
	const classes = useStyles();

	return (
		<Container className={`${classes.mainContainer}${className ? ` ${className}` : ""}`}>
			<div className={classes.contentWrapper}>{children}</div>
		</Container>
	);
};

export default MainContainer;
